import React,{useState,useEffect} from "react";
import Select from 'react-select'


import { fetchCall } from "../../../common/FetchHelpers";

const UserSelectBox = (props)=>{

    const usersUrl = "api/user-account/on-behalf-users";

    const [supportingUsers, setSupportingUsers] = useState({users:[], loading:true});
    
    const setSelectedOption = (selectedOption)=>{
        props.onSelected({target:{name:props.name, ...selectedOption}});
    }

    const compClass=`form-item ${props.styleClass??''}`;

    let labelClass = props.labelClass??"form-item-label";
    let controlClass = props.controlClass??"form-item-value";
    

    useEffect(()=>{
        fetchCall(usersUrl)
        .then((result) => {
            const userList = result.map(item => {
                const obj = {
                    value: item.indexID,
                    label: item.name
                };               
                return obj
            });
            setSupportingUsers({users:userList, loading:false});
          },
          (err) => {
            console.log(err);
          }
        );

      },[]);


    return(
        <div className={compClass}>
            <label className={labelClass}>{props.label}</label>
            <Select className={controlClass} isClearable={true} options={supportingUsers.users} defaultValue={props.value || 'Select'} onChange={setSelectedOption} isLoading={supportingUsers.loading}/>
        </div>
    )
};

export default UserSelectBox;

